package com.dotdrives.web.pages.forms

import com.dotdrives.controller.FormBuilderController
import com.dotdrives.controller.FormsBoardController
import com.dotdrives.controller.NewFormController
import com.dotdrives.repository.SupabaseFormRepository
import com.dotdrives.web.shell.NavItem
import com.dotdrives.web.shell.PortalShell
import com.dotdrives.web.ui.useFlowState
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.awaitCancellation
import kotlinx.coroutines.cancel
import react.FC
import react.Props
import react.useEffect
import react.useState

private class FormsControllerHolder(
    val scope: kotlinx.coroutines.CoroutineScope,
    val board: FormsBoardController,
    val builder: FormBuilderController,
    val newForm: NewFormController,
)

external interface FormsPortalProps : Props {
    var orgId: String
    var userInitials: String
    var userName: String
    var orgName: String
    var canWrite: Boolean
    var onSwitchOrg: () -> Unit
    var onNavigate: (NavItem) -> Unit
    var onSignOut: () -> Unit
}

val FormsPortal = FC<FormsPortalProps> { props ->
    val (holder) = useState {
        val scope = MainScope()
        val repo = SupabaseFormRepository()
        FormsControllerHolder(
            scope = scope,
            board = FormsBoardController(repo, scope, props.orgId),
            builder = FormBuilderController(repo, scope, props.orgId),
            newForm = NewFormController(repo, scope, props.orgId),
        )
    }
    val boardState = useFlowState(holder.board.state)
    val builderState = useFlowState(holder.builder.state)
    val newFormState = useFlowState(holder.newForm.state)

    useEffect(holder) {
        try {
            awaitCancellation()
        } finally {
            holder.scope.cancel()
        }
    }

    PortalShell {
        active = NavItem.Forms
        onNavigate = props.onNavigate
        userInitials = props.userInitials
        userName = props.userName
        orgName = props.orgName
        onSwitchOrg = props.onSwitchOrg
        onSignOut = props.onSignOut

        FormsPage {
            boardController = holder.board
            this.boardState = boardState
            builderController = holder.builder
            this.builderState = builderState
            newFormController = holder.newForm
            this.newFormState = newFormState
            canWrite = props.canWrite
            orgId = props.orgId
            orgName = props.orgName
            onConnectStripe = { props.onNavigate(NavItem.Settings) }
        }
    }
}
